// extracted by mini-css-extract-plugin
export default {"container":"w1-z","heading":"x1-z","links":"y1-z","copy":"z1-z","subCopy":"A1-z","linksLeft":"B1-z","linksCenter":"C1-z","linksRight":"D1-z","link":"E1-z","onlyLink":"F1-z"};